<template>
  <div class="cl-inner">

    <!-- 操作 -->
    <div class="person-oper">
      <a-button v-if="addShow" type="primary" icon="plus" @click="add()">新建</a-button>
    </div>

    <!-- 表格数据 -->
    <a-table
      :columns="columns"
      :dataSource="dataSource"
      :loading="loading"
      :pagination="pagination"
      class="c-table"
      @change="handleTableChange"
    >
      <span slot="imgUrl" slot-scope="text,record"><img :src="record.imgUrl" height="30px" alt="缩略图" @click="show(record.imgUrl)" @error="errorLoadImg"/></span>
      <span slot="action" slot-scope="text,record">
        <template>
          <!-- <a @click="edit(record.id)">修改</a>
          <a-divider type="vertical" /> -->
          <a @click="del(record.id)">删除</a>
        </template>
      </span>
    </a-table>
    <a-modal :maskClosable="false" :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="example" style="width: 100%" :src="previewImage" @error="errorLoadImg"/>
    </a-modal>
    <web-site-wonderful-form-modal ref="webSiteWonderfulForm"></web-site-wonderful-form-modal>
  </div>
</template>
<script>
import CTable from "../../components/CTable";
import notification from "ant-design-vue/es/notification";
import webSiteWonderful from "../../api/webSiteWonderful";
import WebSiteWonderfulFormModal from "../webSiteWonderful/WebSiteWonderfulFormModal";

const columns = [
  {
    title: "标题",
    dataIndex: "title",
    key: "title"
  },
  {
    title: "缩略图",
    dataIndex: "imgUrl",
    key: "imgUrl",
    scopedSlots: { customRender: "imgUrl" }
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    scopedSlots: { customRender: "action" }
  }
];

export default {
  name: "webSitewonderfulList",
  data() {
    return {
        addShow:false,
        previewVisible: false,
        previewImage: '',
        dataSource: [],
        columns,
        loading: false,
        pagination:false,
    };
  },
  components: {
    CTable,WebSiteWonderfulFormModal
  },
  methods: {

    show(url){
      this.previewImage=url;
      this.previewVisible=true;
    },
    //列表
    getWonderfulList(params) {
      let p =params;
      p.moduleType = 2;
      this.loading = true;
      webSiteWonderful.list(p).then(res => {
        console.log('数据：',res)
        // this.pagination = res.data.pagination;
        this.dataSource = res.data.records;
        res.data.records.length>2?this.addShow=false:this.addShow=true;
        this.loading = false;
      });
    },
    handleTableChange(pagination, filters, sorter) {
      // console.log(pagination);
      // const pager = { ...this.pagination };
      // pager.current = pagination.current;
      // this.pagination = pager;
      // this.getWonderfulList({
      //   currentPage: pagination.current,
      //   pageSize: pagination.pageSize
      // });
    },
    //新增
    add(value) {
      this.$refs.webSiteWonderfulForm.init('add',{ id: -1})
    },
    edit(value) {
      this.$refs.webSiteWonderfulForm.init('edit',{ id: value ? value : -1})
    },
    del(id) {
      let that = this;
      this.$confirm({
        title: "提示",
        content: "您此次操作将会删除此广告，请确认您是否要删除?",
        okText: "是",
        okType: "danger",
        cancelText: "否",
        onOk() {
          webSiteWonderful.del({ id }).then(res => {
            console.log(res);
            notification.success({
              message: "消息",
              description: "删除成功！"
            });
            that.getWonderfulList({
              // currentPage: that.pagination.current
              currentPage: 1
            });
          });
        },
        onCancel() {
          console.log("Cancel");
        }
      });
    }
  },
  created() {
    this.getWonderfulList({currentPage:1,pageSize:10});
  }
};
</script>
<style lang="scss" scoped>
@import "src/config/var";
.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}
.search-oper {
  button {
    margin: 0px 5px;
  }
}
.person-oper {
  margin: 20px 0px 30px;
}
</style>